import { DraftAgent } from '@blockpulse3/graphql/hooks';

// /**
//  * isLegalForm.
//  * Type constraint function to check if the current form is a Legal one or not.
//  */
// export function isLegalForm(
//   form: ILegalOtherRoleForm | INaturalOtherRoleForm,
// ): form is ILegalOtherRoleForm {
//   return (form as ILegalOtherRoleForm).name !== undefined;
// }

// /**
//  * isFormValid.
//  * Function to check if the current form is valid. Using a synchronous
//  * yup validation function.
//  *
//  * @param {IOtherRoleForm} rep
//  * @returns {boolean}
//  */
// export function isFormValid(rep: IOtherRoleForm): boolean {
//   if (rep.isLegal) {
//     return schemaLegal.isValidSync(rep.quality);
//   }
//   return schemaNatural.isValidSync(rep.quality);
// }

/**
 * draftAgentTitle.
 * Function to return the "title" of the form.
 * For a legal one, it's the company name (.name) and firstName and lastName for a
 * natural one.
 *
 * @param {DraftAgent} draftAgent
 * @returns {string}
 */
export function draftAgentTitle(draftAgent: DraftAgent): string {
  return `${draftAgent.firstName} ${draftAgent.lastName}`;
}
